import {IntermediatePart} from "../../intermediatePart";

export default class Attachment extends IntermediatePart {

  constructor(isChild, decorCount) {
    super(isChild);
    this.decorCount = decorCount;
    this.partId = "attachment_" + decorCount;
    this.partName = "Attachment " + decorCount;
    this.translateId = "visualizer.bathroom.accessories2";
    this.canBeDisabled = true;
  }
  load(dbFeature) {
    return super.load_(dbFeature, new Attachment(false, this.decorCount));
  }

  setLayers(layout) {
    const activeFeatures = layout.getActiveFeatures(true, true);
    if (this.activeFeature
      && this.activeFeature.metaData["MatchingFeature"]
      && !activeFeatures.some(cartItem => cartItem.cartFeature.metaData["MatchingFeature"]
      && cartItem.cartFeature.metaData["MatchingFeature"][0] === this.activeFeature.metaData["MatchingFeature"][0])) {
      return this.hideLayers();
    }
    return super.setLayers(layout);
  }

}
